import ScreenPieces from '../ScreenComponents/ScreenPieces';
import * as StyleFunctions from '../utilities/StyleFunctions';
import {useState, useRef} from 'react';
import * as ResponsiveFns from '../utilities/ResponsiveFns';

function App(props) {

  var w = props.w;
  var overallWidth = props.overallWidth;
  var h = props.h;
  var onClick = props.onClick;
  var whichFEOrPU = props.whichFEOrPU;
  var currentList = props.currentList;
  var error = props.error;
  var offsetLeft = props.offsetLeft;
  var offsetTop = props.offsetTop;
  var chains = props.chains;

  var bottomBitStyle = {position:'absolute',left:0,right:0,top:0,bottom:0,zIndex:1000};
  var bottomBit = <div style={bottomBitStyle} onClick={onClick}/>
  const [screenRefs, setScreenRefs] = useState({});
  const [otherInfo, setOtherInfo] = useState({});

  var urlParamsForExecution = '';
  var urlHeader = 'https://www.cues.sg/dapps/XXXX';
  var pageRef = useRef();

  var screenSelectionChoices = {};

    var inputValues = {};
  var internalVariables = StyleFunctions.getInternalVariables(otherInfo, setOtherInfo, whichFEOrPU);
  var ownVariables = StyleFunctions.getOwnVariableDefaultValues(currentList, internalVariables, w*4, h*4, '', 'https://www.cues.sg/dapps/XXXX', chains);

  function nullFn(){
  }

  function interactionFn(e){
  }

  var offsetLeft1 = offsetLeft;
  var offsetTop1 = offsetTop;
  if (pageRef && pageRef.current){
    offsetLeft1 += 2 + pageRef.current.offsetLeft;
    offsetTop1 += 2 + pageRef.current.offsetTop;
  }
  var lastEdited = '';

  var xx;
  if (whichFEOrPU.t === 'fe'){
    xx = <ScreenPieces chains={chains} scale={0.25} actualWidth={w*4} insetWidth={w*4} insetHeight={h*4} overallWidth={overallWidth} currentList={currentList} organicChanges={false} itemEdited={false} setItemEdited={false} whichFEOrPU={whichFEOrPU} onClickItemChangeSelection={false} otherPeoplesPositions={[]} internalVariables={internalVariables} updatesToPropagate={[]} error={error} refObject={false} getRef1={false} inputValues={inputValues} ownVariables={ownVariables} alertVisibility={{}} setInputValues={nullFn} interactionFn={interactionFn} setIsShowingSomeDropDown={false} isShowingSomeDropDown={false} bottomBit={bottomBit} style={{position:'relative'}} className='divContainer' userNos={-1} userID={-1} setIsClickingOnContentDiv={false} isClickingOnContentDiv={false} screenRefs={screenRefs} setScreenRefs={setScreenRefs} addWhereText='' potentiallyAddWhichItem='' changeTab={false} tabSelected={false} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={nullFn} popUps={[]} setPopUps={nullFn} hidePanelRelativeItems={{}} flashHighlight={false} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} reportPageHeight={false} offsetTop={offsetTop1 / 0.25} offsetLeft={offsetLeft1 / 0.25} lastEdited={lastEdited} counter={0}/>      
  }else{

    var puV = whichFEOrPU.v;
    var upwardInfo = [];
    var pageS = StyleFunctions.evaluateStyleR('PAGE', currentList.pu[puV].s, ['pu', puV, 's'], currentList, internalVariables, w*4, h*4, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
    var popUpPadding = pageS.popUpPadding;
    var actWidth = ResponsiveFns.resolveSingular(pageS.w, w*4, h*4);
    var backgroundColor = StyleFunctions.combineRGBAndOpacity(pageS.backgroundColor, pageS.paddingOpacity);

    var x = <ScreenPieces chains={chains} scale={0.25} actualWidth={actWidth} insetWidth={w*4} insetHeight={h*4} overallWidth={overallWidth} currentList={currentList} organicChanges={false} itemEdited={false} setItemEdited={false} whichFEOrPU={whichFEOrPU} onClickItemChangeSelection={false} otherPeoplesPositions={[]} internalVariables={internalVariables} updatesToPropagate={[]} error={error} refObject={false} getRef1={false} inputValues={inputValues}  ownVariables={ownVariables} alertVisibility={{}} setInputValues={nullFn} interactionFn={interactionFn} setIsShowingSomeDropDown={false} isShowingSomeDropDown={false} bottomBit={bottomBit} style={{position:'relative', maxHeight:(h*4 - 2 * popUpPadding), maxWidth:w*4, overflow:'scroll'}} className='' userNos={-1} userID={-1} setIsClickingOnContentDiv={false} isClickingOnContentDiv={false} screenRefs={screenRefs} setScreenRefs={setScreenRefs} addWhereText='' potentiallyAddWhichItem='' changeTab={false} tabSelected={false} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={nullFn} popUps={[]} setPopUps={nullFn} hidePanelRelativeItems={{}} flashHighlight={false} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} reportPageHeight={false} offsetTop={offsetTop1 / 0.25} offsetLeft={offsetLeft1 / 0.25} lastEdited={lastEdited} counter={0}/>      
    xx = <table style={{width:w*4,height:h*4,verticalAlign:'middle', backgroundColor, paddingTop:popUpPadding, paddingBottom:popUpPadding}} className='divContainer'><tbody><tr><td>{x}</td></tr></tbody></table>
  }

  function onMouseOver1(e){
    e.preventDefault();
  }

  return <div style={{width:w+1, height:h+1, overflow:'hidden', cursor:'pointer', zIndex:0}} className='pageSelector' onMouseOver={onMouseOver1} onClick={onClick} ref={pageRef}>{xx}</div>



}

export default App;
